<template>
  <div class="quarterly-data-report-manage">
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div class="btn-box">
        <input-select selectTitle="状态" :selectKey="'status'" :selectData="statusList" @search="search" style="margin-right: 10px;"/>
      </div>
      <input-search placeholder="任务名称" @search="searchKey" />
    </div>
    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" deleteTipInfo="是否确认删除此数据" @deleteLine="deleteLine" @quickReport="quickReport" @queryState="queryState" @changeSelection="changeSelection" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" @toCurrentPage="toModifyPage" :operationArr="operationArr" />

  </div>
</template>

<script>
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
import ButtonDelete from '../../../components/Button/ButtonDelete'
import InputSearch from '../../../components/Input/InputSearch'
import InputSelect from '../../../components/Input/InputSelect'
import TableMain from '../../../components/Table/TableMain'
import {api} from '../../api/PoliticalCommunication'
import {bus} from '../../../utils/bus'
import {errorHandler} from '../../../utils/errorHandler'
import ButtonAdd from '../../../components/common/buttons/button-add'
import {nError, nSuccess} from '../../../utils/notice'
import AuthTree from '../../../components/common/auth-tree'
import ButtonCancel from '../../../components/Button/ButtonCancel'

export default {
  components: {
    ButtonCancel,
    AuthTree,
    ButtonAdd,
    TableMain,
    InputSelect,
    InputSearch,
    ButtonDelete,
    Breadcrumb},
  name: 'annual-data-report-manage',
  data () {
    return {
      permissionCodes: '',
      breadcrumb: [{
        value: '小微政通',
        name: 'quarterly-data-report-manage'
      }, {
        value: '年度数据上报'
      }],
      tableHead: [{
        prop: 'teskName',
        label: '任务名称'
      }, {
        prop: 'approveNodeText',
        label: '当前审批节点'
      }, {
        prop: 'statusText',
        label: '状态'
      }, {
        prop: 'updateTime',
        label: '更新时间'
      }],

      operationArr: ['quickReport', 'queryState', 'current', 'delete'],
      tableData: [],
      total: 0,
      pageSize: 10,
      pageNum: 1,
      selectionArr: [],
      statusList: [
        {key: '', label: '全部'},
        {key: '0', label: '未提交'},
        {key: '1', label: '待审核'},
        {key: '2', label: '已通过'},
        {key: '3', label: '已驳回'},
      ],
      requestData: {
        status: '',
        searchKey: '',
      },
    }
  },
  created () {
    this.getPage()
  },
  activated() {
    this.getPage()
  },
  methods: {
    toModifyPage (code) {
      this.$router.push({
        path: '/annual_data_report_modify/' + code
      })
    },
    getPage () {
      let reqData = this.requestData
      reqData.pageNum = this.pageNum
      reqData.pageSize = this.pageSize
      this.$axios.post(api.getAnnualDataByPage, reqData)
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data.list
            data.map((v, i) => {
              if (v.updateTime) {
                v.updateTime = v.updateTime.slice(0, 19)
              }
              if (v.approveNode === '0') {
                v.approveNodeText = '园区'
                if (v.approveStatus === '0') {
                  v.statusText = '未提交'
                } else if (v.approveStatus === '1') {
                  v.statusText = '待审核'
                } else if (v.approveStatus === '2') {
                  v.statusText = '已通过'
                } else if (v.approveStatus === '3') {
                  v.statusText = '已驳回'
                }
              } else if (v.approveNode === '1') {
                v.approveNodeText = '省平台'
                if (v.status === '0') {
                  v.statusText = '未提交'
                } else if (v.status === '1') {
                  v.statusText = '待审核'
                } else if (v.status === '2') {
                  v.statusText = '已通过'
                } else if (v.status === '3') {
                  v.statusText = '已驳回'
                }
              }
            })
            this.total = res.data.data.total
            this.tableData = data
          }
        })
        .catch(errorHandler('获取信息失败'))
    },
    search (v) {
      this.pageNum = 1
      this.requestData[v.key] = v.value
      this.getPage()
    },
    searchKey (v) {
      this.pageNum = 1
      this.requestData.searchKey = v
      this.getPage()
    },
    changePagination (data) {
      this.pageNum = data[0]
      this.pageSize = data[1]
      this.getPage()
    },
    changeSelection (codeArr) {
      this.selectionArr = codeArr
    },

    // 删除
    deleteLine(code) {
      this.$axios.post(api.deleteAnnualData, code)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess("删除成功");
            this.getPage();
          }
        })
        .catch(errorHandler("删除失败"));
    },

    // 快捷上报
    quickReport (data) {
      this.$confirm('是否确认上报数据？', "提示", {
        type: "warning"
      })
        .then(() => {
          this.$axios.post(`${api.uploadAnnualDataByCode}`, data)
            .then(res => {
              nSuccess('上报成功')
              this.getPage()
            })
            .catch(errorHandler('上报失败'))
        })
        .catch(() => {
          console.log("取消上报");
        });
    },

    // 查询状态
    queryState (data) {
      this.$axios.get(`${api.getAnnualDataStatus}/${data.code}`, {})
        .then(res => {
          nSuccess('已更新至最新状态')
          this.getPage()
        })
        .catch(errorHandler('查询状态失败'))
    }
  },

  watch: {}
}
</script>

<style lang="less" scoped>
.quarterly-data-report-manage {
  .search-line {
    display: flex;
    justify-content: space-between;
    margin: 20px 0;
  }
  .btn-box {
    display: flex;
    justify-content: flex-start;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/PoliticalCommunication/AnnualDataReport/AnnualDataReportManage.vue